import axios from '../utils/axios';

const locationUserService = {
  // Get users for a specific location
  getUsersByLocation: async (locationId) => {
    const response = await axios.get(`/users/location/${locationId}`);
    return response.data;
  },

  // Create a new user for a specific location
  createUser: async (userData) => {
    const response = await axios.post('/users', userData);
    return response.data;
  },

  // Update a user
  updateUser: async (userId, userData) => {
    const response = await axios.put(`/users/${userId}`, userData);
    return response.data;
  },

  // Delete a user
  deleteUser: async (userId) => {
    const response = await axios.delete(`/users/${userId}`);
    return response.data;
  },

  // Get all users (for admin purposes)
  getAllUsers: async (params = {}) => {
    const response = await axios.get('/users', { params });
    return response.data;
  }
};

export default locationUserService;
